  const Admin = () =>
    import ('@/pc/views/admin/admin');
  const claim = () =>
    import ('@/pc/views/claimStore');
  const create = () =>
    import ('@/pc/views/createStore');
  const waiting = () =>
    import ('@/pc/views/base/waiting');
  const userCenter = () =>
    import ('@/pc/views/userCenter');
  const storeSelect = () =>
    import ('@/pc/views/storeSelect');

  import {
    getMenuRouter
  } from '@/pc/privileges/pcMenus';


  var adminRouter = {
    path: '/admin',
    component: Admin,
    children: [{}] //
  }

  var baseLimitRouter = [{ // 认领门店失败
    path: '/claim/:storeId',
    component: claim
  }, { //新建门店
    path: '/create',
    component: create
  }, { //修改门店
    path: '/create/:storeId',
    component: create
  }, { //  个人中心
    path: '/user-center',
    component: userCenter
  }, { //  选择门店
    path: '/store-select',
    component: storeSelect
  }]


  export default (privileges = [], role) => {
    adminRouter.children = getMenuRouter(privileges, role);
    return [...baseLimitRouter, adminRouter];
  }



// WEBPACK FOOTER //
// ./src/router/pc/admin.js